export default "__VITE_ASSET__BNZOn2Qq__"